'use client';

import { PriceActivityItem } from '@/components/help-center/fairtrade/price-activity/PriceActivityItem';
import type { PriceActivityChange } from '@/lib/price-activity-types';

type PriceActivityListProps = {
  changes: PriceActivityChange[];
};

export function PriceActivityList({ changes }: PriceActivityListProps) {
  return (
    <ul className="space-y-2.5">
      {changes.map((change, index) => (
        <PriceActivityItem key={change.id} change={change} index={index} />
      ))}
    </ul>
  );
}
